import React from 'react';
import { Box, Typography, Button ,Grid} from '@mui/material';
import { NavLink } from 'react-router-dom';
import { useLanguage } from '../i18n/LanguageContext';
import logo from '../imaged/logo.jpeg';

const Footer = () => {
  const { t } = useLanguage();
  const scrollTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });
  return (
    <Box id="footer" sx={{ py: { xs: 6, md: 8 }, borderTop: '1px solid', borderColor: 'grey.200', mt: { xs: 4, md: 6 }, bgcolor: 'grey.100' }}>
      <Box sx={{ maxWidth: 1200, mx: 'auto', px: { xs: 2, md: 4 } }}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={4}>
            <Box component="img" src={logo} alt="Paritranam" sx={{ height: 60, mb: 2, borderRadius: '50%' }} />
            <Typography variant="h6" sx={{ fontWeight: 800, mb: 1 }}>{t('footer.brand')}</Typography>
            <Typography variant="body2" color="text.secondary">
              {t('footer.tagline')}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="subtitle2" sx={{ fontWeight: 800, mb: 1 }}>{t('footer.linksTitle')}</Typography>
            <Typography component={NavLink} to="/home" onClick={scrollTop} variant="body2" sx={{ color: 'text.secondary', display: 'block', textDecoration: 'none', py: 0.5, '&.active': { color: 'primary.main' } }}>{t('nav.home')}</Typography>
            <Typography component={NavLink} to="/about-ayurveda" onClick={scrollTop} variant="body2" sx={{ color: 'text.secondary', display: 'block', textDecoration: 'none', py: 0.5, '&.active': { color: 'primary.main' } }}>{t('nav.aboutAyurveda')}</Typography>
            <Typography component={NavLink} to="/about-paritranam" onClick={scrollTop} variant="body2" sx={{ color: 'text.secondary', display: 'block', textDecoration: 'none', py: 0.5, '&.active': { color: 'primary.main' } }}>{t('nav.aboutParitranam')}</Typography>
            <Typography component={NavLink} to="/products" onClick={scrollTop} variant="body2" sx={{ color: 'text.secondary', display: 'block', textDecoration: 'none', py: 0.5, '&.active': { color: 'primary.main' } }}>{t('nav.products')}</Typography>
            <Typography component={NavLink} to="/gallery" onClick={scrollTop} variant="body2" sx={{ color: 'text.secondary', display: 'block', textDecoration: 'none', py: 0.5, '&.active': { color: 'primary.main' } }}>{t('nav.gallery')}</Typography>
            <Typography component={NavLink} to="/contact" onClick={scrollTop} variant="body2" sx={{ color: 'text.secondary', display: 'block', textDecoration: 'none', py: 0.5, '&.active': { color: 'primary.main' } }}>{t('nav.contact')}</Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography variant="subtitle2" sx={{ fontWeight: 800, mb: 1 }}>{t('footer.contactTitle')}</Typography>
            <Typography variant="body2" color="text.secondary">{t('footer.phone')}: +91 9168 800 800</Typography>
            <Typography variant="body2" color="text.secondary">{t('footer.email')}: info@paritranam.com</Typography>
            <Button variant="contained" color="primary" sx={{ mt: 1, borderRadius: 99, px: 3, fontWeight: 700 }} component="a" href="#contact">
              {t('footer.cta')}
            </Button>
            <Box sx={{ mt: 1.5 }}>
              <Button
                component="a"
                href="https://maps.google.com/maps?q=17.6294292%2C74.798539&z=17&hl=en"
                target="_blank"
                rel="noopener noreferrer"
                variant="outlined"
                color="primary"
                sx={{ borderRadius: 50, px: 3, py: 0.8 }}
              >
                View Location
              </Button>
            </Box>
          </Grid>
        </Grid>
        <Box sx={{ borderTop: '1px solid', borderColor: 'grey.200', mt: 3, pt: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap' }}>
          <Typography variant="caption" color="grey.600">© {new Date().getFullYear()} {t('footer.copyright')}</Typography>
          <Typography variant="caption" color="grey.600">{t('footer.slogan')}</Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default Footer;
